import React, { FC, memo } from "react";
import { ISvG } from "~/types/SvGTypes";

const Icon: FC<ISvG> = ({ fill = "#FFF" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.25"
      height="22"
      viewBox="0 0 19.25 22"
    >
      <g id="pdf" transform="translate(-565 -294)">
        <g id="file-extension" transform="translate(545.671 294)">
          <path
            id="Контур_725"
            data-name="Контур 725"
            d="M20.7,0H32.387l6.192,6.168V20.625A1.375,1.375,0,0,1,37.2,22H20.7a1.375,1.375,0,0,1-1.375-1.375V1.375A1.375,1.375,0,0,1,20.7,0Z"
            transform="translate(0)"
            fill="#e2574c"
          />
          <path
            id="Контур_726"
            data-name="Контур 726"
            d="M209.125,6.367h-4.793a1.375,1.375,0,0,1-1.375-1.375V.193Z"
            transform="translate(-170.565 -0.179)"
            fill="#b53629"
          />
        </g>
        <path
          id="Контур_826"
          data-name="Контур 826"
          d="M1.34-2.334V-.977H.376v-4h1.6a1.859,1.859,0,0,1,.812.169,1.273,1.273,0,0,1,.547.481,1.313,1.313,0,0,1,.194.707,1.157,1.157,0,0,1-.419.935,1.738,1.738,0,0,1-1.15.35Zm0-.745h.632a.6.6,0,0,0,.427-.14.521.521,0,0,0,.147-.4A.643.643,0,0,0,2.4-4.062a.535.535,0,0,0-.412-.17H1.34Zm2.867,2.1v-4H5.5a1.9,1.9,0,0,1,.953.24,1.69,1.69,0,0,1,.661.679,2.049,2.049,0,0,1,.24.982v.184a2.061,2.061,0,0,1-.232.985,1.7,1.7,0,0,1-.654.681,1.854,1.854,0,0,1-.941.249Zm.964-3.255v2.514h.335a.75.75,0,0,0,.637-.3,1.447,1.447,0,0,0,.223-.878v-.173a1.435,1.435,0,0,0-.223-.874A.763.763,0,0,0,5.5-4.232ZM10.532-2.57H8.977V-.977H8.013v-4h2.676v.745H8.977v.92h1.555Z"
          transform="translate(569 310)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

export default memo(Icon);
